import { Component } from '@angular/core';

@Component({
  selector: 'app-l-list',
  imports: [],
  templateUrl: './l-list.component.html',
  styleUrl: './l-list.component.css'
})
export class LListComponent {

}
